
<ng-container *ngIf="!loading">
    <app-job-card *ngFor="let job of jobs?.data" [job]="job" [component]="component" [entity]="entity"></app-job-card>
    <p class="my-4 text-sm text-gray-500" *ngIf="!jobs?.data.length" i18n>There are no available vacancies which match your criteria.</p>
</ng-container>

<ng-container *ngIf="loading">
    <app-job-card-husk *ngFor="let job of jobs?.data"></app-job-card-husk>
</ng-container>

<app-paginator [length]="length" [pageSize]="component.resultsPerPage || 10" [component]="component" [pageSizeOptions]="pageSizeOptions"></app-paginator>
